const ROOT = `https://storage.googleapis.com/eleven-public-cdn/images/marketing`;

export const asset = `${ROOT}/projects-hero.png`;

export const config = [
  {
    publication: `${ROOT}/medium-avatar.png`,
  },
  {
    publication: `${ROOT}/washington-post-avatar.png`,
  },
  {
    publication: `${ROOT}/pdf-avatar.png`,
  },
  {
    publication: `${ROOT}/epub-avatar.png`,
  },
];
